import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

/** queryKey: ['loan-demand', moneypoolId, demandId] — carries `events` */
export const getLoanDemand = async (ctx: QueryFunctionContext) => {
    const { data }: { data: ILoanDemandDetail } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/loan-demands/${ctx.queryKey[2]}/`
    )
    return data
}

export const postLoanDemandComment = async (payload: {
    moneypoolId: string | number
    demandId: string | number
    note: string
}) => {
    const { data }: { data: ILoanDemandEvent } = await request.post(
        `/api/v1/moneypools/${payload.moneypoolId}/loan-demands/${payload.demandId}/comments/`,
        { note: payload.note }
    )
    return data
}

/**
 * Toggles. The endpoint flips the like rather than taking a desired state, so
 * two taps land back where you started — the caller must not "retry" it.
 *
 * POST rather than the GET Android sends: the backend accepts both, and a GET
 * that mutates is not something to spread to a new client.
 */
export const toggleLoanDemandLike = async (payload: {
    moneypoolId: string | number
    demandId: string | number
}) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneypoolId}/loan-demands/${payload.demandId}/like/`
    )
    return data
}
